import { RouteLocation, RouteLocationRaw } from 'vue-router'
import PAGE_NAME from '@web/consts/PAGE_NAME'
import Token from '@web/common/token'
import { consumePendingUrlToken } from '@web/common/stripUrlToken'
import { sanitizeReturnUrl } from '@web/common/returnUrl'

/**
 * Редирект `/auto-login?token=…&returnUrl=…`.
 *
 * Токен обычно уже снят с URL при создании history (stripUrlToken в
 * router/config.ts), чтобы JWT не попал в page_location аналитики, — берём его
 * оттуда. to.query.token остаётся запасным источником для переходов внутри SPA.
 *
 * returnUrl принимаем только на домен платформы: иначе ссылка автологина
 * работает как открытый редирект, а `javascript:` выполнился бы на нашем origin.
 *
 * Отдельным модулем, а не внутри router/config.ts: config при вычислении
 * создаёт history, и тесты не могут импортировать его без побочных эффектов.
 */
export function createAutoLoginRedirect ({
  logout,
  navigate = (url) => { window.location.replace(url) }
}: {
  logout: () => void
  navigate?: (url: string) => void
}) {
  return (to: RouteLocation): RouteLocationRaw => {
    const token = to.query.token ? String(to.query.token) : consumePendingUrlToken()
    if (!token) {
      return { name: PAGE_NAME.LOGIN }
    }

    logout()
    Token.set(token)

    const returnUrl = sanitizeReturnUrl(to.query.returnUrl)
    if (returnUrl) {
      // replace, а не href: адрес автологина не остаётся в истории браузера.
      navigate(returnUrl)
    }
    return { name: PAGE_NAME.HOME }
  }
}
